import React, { FC } from 'react';
import { Start, Stop } from './styles';

const Facebook: FC<SVGIconProps> = ({ linearGradient }) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M32.0002 5.43994C17.3335 5.43994 5.3335 17.4133 5.3335 32.1599C5.3335 45.4933 15.0935 56.5599 27.8402 58.5599V39.8933H21.0668V32.1599H27.8402V26.2666C27.8402 19.5733 31.8135 15.8933 37.9202 15.8933C40.8268 15.8933 43.8668 16.3999 43.8668 16.3999V22.9866H40.5068C37.2002 22.9866 36.1602 25.0399 36.1602 27.1466V32.1599H43.5735L42.3735 39.8933H36.1602V58.5599C42.444 57.5675 48.166 54.3613 52.2933 49.5201C56.4206 44.6789 58.6811 38.5217 58.6668 32.1599C58.6668 17.4133 46.6668 5.43994 32.0002 5.43994Z"
      fill="url(#paint0_linear_173_155)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_173_155"
        x1="32.0002"
        y1="5.43994"
        x2="44.5002"
        y2="124.5"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default Facebook;
